
import { useEffect } from 'react';
import RouterConfig from './navigation';

const App = () => {

  //REMOVE RIGHT CLICK MENU ON BROWSER
  useEffect(() => {
  const handleContextMenu = (e: MouseEvent) => {
    if ((e.target as HTMLElement)?.tagName === "IMG") {
      e.preventDefault();
    }
  };

  document.addEventListener("contextmenu", handleContextMenu);

  return () => {
    document.removeEventListener("contextmenu", handleContextMenu);
  };
}, []);
  return <RouterConfig />;

};


export default App;
